import React, { useEffect, useState, useContext, useMemo, useCallback } from 'react';
import { DeleteSessionSetup, AddSessionSetup, AddSetups, CurrentSessionHasBallSeries, AddSessionSetupsAndSeries, UpdateCurrentSession, GetCurrentSession, SetCurrentSession, SelectSessionSetup, UpdateSetup } from '../isdlData/sessionData';
import './Components.css';
import DataGrid from 'react-data-grid';
// import 'react-data-grid/lib/styles.css';
import { SetupColors, LMList } from '../utils/LMConstants';
import { Modal } from '@mui/material';
import NewSetup from './NewSetup';
import DeleteSetup from './DeleteSetup';
import { session_update } from '../mobile/mobileHandler';
import { AppContext, LMDrawingContext, LMShowEllipseContext, ViewOnlyContext } from '../contexts/AppContext';
import SetupListSelectHeader from './custom/SetupListSelectHeader';
import {Cross2Icon} from './../icons/Icons';
import GolferDisplay from './GolferDisplay';
import SetupsList from './SetupsList';
import ResearchQuadMasses from './ResearchQuadMasses';
import { useAppStateService } from '../contexts/AppState';

function Setups({currentSession, setCurrentSetup, drawerOpenState, handleSessionChange}){
    // const [selectedSession, setSelectedSession] = useState(null);
    const [selectedSetup, setSelectedSetup] = useState(null);
    const [newSetupOpen, setNewSetupOpen] = useState(false);
    const [deleteSetupOpen, setDeleteSetupOpen] = useState(false);
    const [useSeries, SetUseSeries] = useState(false);
    const [rows, SetRows] = useState([]);
    const [currentLMs, SetCurrentLMs] = useState([]);
    const [researchQuadMasses, setResearchQuadMasses] = useState({ plate: '', plateBall: '', head: '', headBall: '' });

    const appState = useAppStateService();
    const { lmDrawing, setLMDrawing }= useContext(LMDrawingContext);
    const { LMShowEllipse, setLMShowEllipse } = useContext(LMShowEllipseContext);
    const { viewOnly } = useContext(ViewOnlyContext);
    // const { drawingLM, setDrawingLM } = useLMDrawing();

    const researchQuadConnected = useMemo(() => {
        if (Array.isArray(currentSession?.ConnectedLMs)) {
            return currentSession.ConnectedLMs.includes('RESEARCH_QUAD');
        }

        if (!currentSession?.SessionSetups) {
            return false;
        }

        return currentSession.SessionSetups.some((sessionSetup) =>
            sessionSetup?.Shots?.some((shot) =>
                shot?.LMInfos?.some((lmInfo) => lmInfo?.LMType === 'RESEARCH_QUAD')
            )
        );
    }, [currentSession]);

    useEffect(() => {
        getUniqueLMs(currentSession);
        if(currentSession.SessionSetups && currentSession.SessionSetups.length > 0)
            setSelectedSetup(currentSession.SessionSetups.find(setup => setup.IsSelected));

      }, [currentSession]);

    useEffect(() => {
        const inputs = selectedSetup?.CannonCor?.inputs;
        const normalize = (value) => (value === null || value === undefined ? '' : String(value));

        const nextMasses = inputs ? {
            plate: normalize(inputs.plateMass),
            plateBall: normalize(inputs.plateBallMass),
            head: normalize(inputs.headMass),
            headBall: normalize(inputs.headBallMass)
        } : { plate: '', plateBall: '', head: '', headBall: '' };

        setResearchQuadMasses((prev) => {
            if (
                prev.plate === nextMasses.plate &&
                prev.plateBall === nextMasses.plateBall &&
                prev.head === nextMasses.head &&
                prev.headBall === nextMasses.headBall
            ) {
                return prev;
            }
            return nextMasses;
        });
    }, [selectedSetup?.Id, selectedSetup?.CannonCor]);

      

    

    const handleNewSetup = async (setup) => {
        SelectSessionSetup(GetCurrentSession(), setup, false);
        const currentSession = GetCurrentSession();
        await AddSessionSetup(setup);

        // for(let i = 0; i < currentSession.SessionSetups.length; i++){

        //     if(currentSession.SessionSetups[i].Id === setup.Id)
        //         currentSession.SessionSetups[i].IsSelected = true;
        //     else
        //         currentSession.SessionSetups[i].IsSelected = false;
        // }

        setCurrentSetup(setup.Id);

        session_update(currentSession.id, setup.Id, viewOnly);

        SetUseSeries(CurrentSessionHasBallSeries());
    };

    const handleNewMultipleSetups = async (setups, series) => {
        await AddSessionSetupsAndSeries(setups,series);
        const firstSetup = currentSession.SessionSetups[0];
        setSelectedSetup(firstSetup);

        for(let i = 0; i < currentSession.SessionSetups.length; i++){

            if(currentSession.SessionSetups[i].Id === firstSetup.Id)
                currentSession.SessionSetups[i].IsSelected = true;
            else
                currentSession.SessionSetups[i].IsSelected = false;
        }

        setCurrentSetup(firstSetup.Id);
            session_update(currentSession.id, firstSetup.Id, viewOnly);

        SetUseSeries(CurrentSessionHasBallSeries());
    };

    const handleDeleteSetup = async () =>{
        let deletedSetupId = "";
        if(currentSession.SessionSetups.length === 1){
            deletedSetupId = selectedSetup.Id;
        }

        //delete setup logic
        await DeleteSessionSetup(selectedSetup.Id);
        
        if(currentSession.SessionSetups.length > 1){
            const newCurrentSetup = currentSession.SessionSetups[0];

                session_update(currentSession.id, newCurrentSetup.Id, viewOnly);
            setSelectedSetup(currentSession.SessionSetups.find(s => s.Id == newCurrentSetup.Id));
            setCurrentSetup(newCurrentSetup.Id);
        }else if(currentSession.SessionSetups.length === 0){
                session_update(currentSession.id, "no_setup");

            setSelectedSetup(null);
            setCurrentSetup(null);
        }
    };

    function GetShotCount(){
        let shotCount = 0;

        if(currentSession && currentSession.SessionSetups){
            for(let i = 0; i < currentSession.SessionSetups.length; i++){
                if(currentSession.SessionSetups[i].Shots){
                    shotCount += currentSession.SessionSetups[i].Shots.length;
                }
            }
        }

        return shotCount.toString() + " shot" + (shotCount > 1 || shotCount === 0 ? "s" : "");
    }

    const handleDrawEllipse = (e) =>{
        setLMShowEllipse(e.target.checked);
    };

    const handleCannonCorComputed = useCallback((payload) => {
        if (!currentSession || !selectedSetup || viewOnly) {
            return;
        }

        const nextInputs = payload?.inputs || {};
        const nextResults = payload?.results || {};
        const existingInputs = selectedSetup.CannonCor?.inputs || {};
        const existingResults = selectedSetup.CannonCor?.results || {};
        const existingConfirmation = selectedSetup.CannonCor?.confirmation || {};
        const nextSignature = payload?.meta?.confirmationSignature || '';
        const nextConfirmation = (
            existingConfirmation.confirmed === true &&
            existingConfirmation.signature === nextSignature
        ) ? existingConfirmation : {
            confirmed: false,
            signature: nextSignature
        };

        const inputsMatch = JSON.stringify(existingInputs) === JSON.stringify(nextInputs);
        const resultsMatch = JSON.stringify(existingResults) === JSON.stringify(nextResults);
        const confirmationMatch = JSON.stringify(existingConfirmation) === JSON.stringify(nextConfirmation);

        if (inputsMatch && resultsMatch && confirmationMatch) {
            return;
        }

        UpdateSetup(selectedSetup, {
            CannonCor: {
                inputs: nextInputs,
                results: nextResults,
                confirmation: nextConfirmation
            }
        });
    }, [currentSession, selectedSetup, viewOnly]);

    function getUniqueLMs(data){
        const  uniqueLMTypes = new Set();

        if(!data.SessionSetups){
            setLMDrawing([]);
            return;
        }

        data.SessionSetups.forEach(sessionSetup => {
            // Iterate through the Shots in each SessionSetup
            if(sessionSetup.Shots){
                sessionSetup.Shots.forEach(shot => {
                    // Iterate through the LMInfos in each Shot
                    shot.LMInfos.forEach(lmInfo => {
                        // Add the LMType to the set
                        const lmData = LMList.find(lm => lm.type === lmInfo.LMType);
    
                        if(lmData.hasTraj && lmData.hasTraj){
                            uniqueLMTypes.add(lmInfo.LMType);
                        }
                    });
                });
            }
        });

        const lms = Array.from(uniqueLMTypes);
        if(lms.length > 0){
            setLMDrawing(prev => (prev && lms.includes(prev) ? prev : lms[0] ?? []));
        }
        SetCurrentLMs(lms);
    }

    const handleLMChange = (e) => {
        setLMDrawing(e.target.id);
    }

    return(
        <div className='setup-container' style={{minHeight:'100%', width:'350px'}}>
            <button style={{width:'40px', height:'40px', marginRight:'auto', background:'transparent', border:'0px'}} onClick={drawerOpenState(false)}>
                <Cross2Icon width='40px' height='40px'/>
            </button>
            <div style={{overflowY:'auto', alignItems:'center', width:'100%'}}>
                <h2 style={{textAlign:'center'}}>{currentSession?.EntityType === "Test" ? "Test" : "Golfer"}</h2>
                <GolferDisplay CurrentSession={currentSession} SessionChanged={handleSessionChange}/>
                <SetupsList currentSession={currentSession} setCurrentSetup={setCurrentSetup}/>
                <ResearchQuadMasses
                    visible={researchQuadConnected}
                    selectedSetup={selectedSetup}
                    masses={researchQuadMasses}
                    onMassChange={setResearchQuadMasses}
                    onCorComputed={handleCannonCorComputed}
                    corShots={currentSession?.SessionSetups?.[0]?.shots?.shotCount ?? 0}
                    rows={selectedSetup ? [selectedSetup] : []}
                    //plateshots
                    //headshots
                />
                <div className='setup-shotcount-container'>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <input type="checkbox" name='ellipseCheckbox' style={{width:'25px', height:'25px'}} onChange={handleDrawEllipse} checked={LMShowEllipse}/>
                        <label htmlFor='ellipseCheckbox' style={{marginLeft:'5px'}}>Show Ellipses</label>
                    </div>
                    {GetShotCount()}
                </div>
                <div className='setup-lms-container'>
                    <div style={{padding: '5px'}}>Displayed Launch Monitors</div>
                    {currentLMs.map((item,index) => (
                        <div key={index} style={{display: 'flex', alignItems: 'center', width: '100%', background: LMList.find(l => l.type === item).color, padding: '5px'}}>
                            <input type="radio" id={item} name="LM" value={item} onChange={handleLMChange} checked={lmDrawing === item} style={{width:'20px', height:'20px'}}/>
                            <label htmlFor={item} style={{marginLeft:'5px', color:'black', fontWeight:'bold'}}>{item}</label>
                        </div>
                    ))}
                </div>
            </div>
                
                <Modal
                    open={newSetupOpen}>
                        <NewSetup setModalState={setNewSetupOpen} addNewSetup={handleNewSetup} addMultipleNewSetups={handleNewMultipleSetups}/>
                </Modal>
                <Modal
                    open={deleteSetupOpen}>
                        <DeleteSetup selectedSetup={selectedSetup} setDeleteModalState={setDeleteSetupOpen} deleteSetup={handleDeleteSetup}/>
                </Modal>
        </div>
    );
}

export default Setups;
